export class GenericHtmlPage {
  public html: string;
  public css: string;
  public script: string;
  public title: string;
}
